import ReactDOM from "react-dom/client";
import { ComponentLegacy } from "mobile/LegacyMobile";
import reportWebVitals from "reportWebVitals";

import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import { registerServiceWorker } from "shared/helpers/serviceWorkerRegistration";

import "i18n";

registerServiceWorker();

ReactDOM.createRoot(document.getElementById("terms_title")).render(
  <ErrorBoundary>
    <ComponentLegacy />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
